module.exports = __webpack_public_path__ + "static/media/LTDLogo.548def78.jpg";